import React from "react";

const InsuranceNoticeInfoIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
    <path
      transform="translate(1.667 1.667)"
      d="M8.333 0C3.733 0 0 3.733 0 8.333C0 12.933 3.733 16.667 8.333 16.667C12.933 16.667 16.667 12.933 16.667 8.333C16.667 3.733 12.933 0 8.333 0ZM9.167 12.5L7.5 12.5L7.5 7.5L9.167 7.5L9.167 12.5ZM9.167 5.833L7.5 5.833L7.5 4.167L9.167 4.167L9.167 5.833Z"
      fill="currentColor"
    />
  </svg>
);

export default InsuranceNoticeInfoIcon;
